//- Absence Request Headers
import moment from 'moment'
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'RUT',
        value: ({ hr_employee }) => {
            return hr_employee.rut
        },
    },
    {
        text: 'Empleado',
        value: ({ hr_employee }) => {
            return (
                hr_employee.names +
                ' ' +
                hr_employee.last_name1 +
                ' ' +
                hr_employee.last_name2
            )
        },
    },
    {
        text: 'Motivo',
        value: ({ hr_absence_request_type }) => {
            return hr_absence_request_type.type
        },
    },
    {
        text: 'Inicio',
        value: ({ init_date }) => {
            return moment(init_date).format('DD-MM-YYYY')
        },
    },
    {
        text: 'Término',
        value: ({ end_date }) => {
            return moment(end_date).format('DD-MM-YYYY')
        },
    },
    {
        text: 'Días',
        value: 'days',
    },

    {
        text: 'Estado',
        value: ({ hr_absence_request_status }) => {
            return hr_absence_request_status.status
        },
    },
]
